import { h, Fragment } from "preact";
import { useContext, useEffect, useMemo, useRef, useState } from "preact/hooks";
import TextInput from "../../../../../common/TextInput";
import { checkEmail } from "../../../../../../tools";
import {
  sendVerificationCode,
  checkVerificationCode,
} from "../../../hooks/useSendCode";
import { APARTMENT_FORM_TYPE } from "../../../../ApartmentForm.types";

export default function OwnerStepBuy({ formContext, onNext, type }) {
  const { formData, props } = useContext(formContext);
  console.log(props);
  const { address, accountNumber } = formData;

  const phoneInputRef = useRef(null);
  const additionalPhoneInputRef = useRef(null);

  const [ownerData, setOwnerData] = useState({
    lastName: formData.lastName,
    firstName: formData.firstName,
    middleName: formData.middleName,
    phone: formData.phone,
    smsCode: "",
    phoneVerified: formData.phoneVerified || false,
    additionalPhone: formData.additionalPhone || "",
    additionalSmsCode: "",
    additionalPhoneVerified: formData.additionalPhoneVerified || false,
    email: formData.email,
    removeAddress: formData.removeAddress || false,
  });

  const [token, setToken] = useState(null);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};
    if (!ownerData.lastName) newErrors.lastName = "Введите фамилию";
    if (!ownerData.firstName) newErrors.firstName = "Введите имя";
    if (!ownerData.phoneVerified) newErrors.phone = "Подтвердите номер";
    if (ownerData.email && !checkEmail(ownerData.email))
      newErrors.email = "Введите корректный email";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === "email" && value && !checkEmail(value)) {
      setErrors((prev) => ({ ...prev, email: "Введите корректный email" }));
    } else {
      setOwnerData((prev) => ({ ...prev, [id]: value }));
    }
    if (errors[id]) setErrors((prev) => ({ ...prev, [id]: "" }));
  };

  const sendSmsCode = (phoneType) => {
    if (!ownerData[phoneType].trim()) {
      setErrors((prev) => ({ ...prev, [phoneType]: "Введите номер телефона" }));
      return;
    }
    setErrors((prev) => ({ ...prev, [phoneType]: "" }));
    sendVerificationCode(ownerData[phoneType], setToken);
  };

  const verifySmsCode = (phoneType, codeType) => {
    if (token === null) return;

    let result = checkVerificationCode(
      ownerData[phoneType],
      ownerData[codeType],
      token
    ).then((response) => {
      if (response === true) {
        setOwnerData((prev) => ({ ...prev, [phoneType + "Verified"]: true }));
        setErrors((prev) => ({ ...prev, [codeType]: "" }));
      } else {
        setErrors((prev) => ({ ...prev, [codeType]: "Неверный код" }));
      }
    });
  };

  const handleNext = () => {
    if (validateForm()) {
      if (type === APARTMENT_FORM_TYPE.BUY) {
        ym(51133895, "reachGoal", "flat_buy");
      } else if (type === APARTMENT_FORM_TYPE.HERITAGE) {
        ym(51133895, "reachGoal", "flat_heritage");
      }
      onNext(ownerData);
    }
  };

  const isFormValid = useMemo(() => {
    return (
      ownerData.lastName &&
      ownerData.firstName &&
      ownerData.phoneVerified &&
      !Object.values(errors).some((error) => error)
    );
  }, [ownerData, errors]);

  console.log("isFormValid", isFormValid);

  useEffect(() => {
    if (phoneInputRef.current) {
      window
        .Inputmask({
          mask: "+7 (999) 999 9999",
          clearIncomplete: true,
          oncomplete: function (e) {
            setOwnerData((prev) => ({ ...prev, phone: e.target.value }));
          },
          onincomplete: function () {
            setOwnerData((prev) => ({ ...prev, phone: "" }));
          },
        })
        .mask(phoneInputRef.current);
    }
    if (additionalPhoneInputRef.current) {
      window
        .Inputmask({
          mask: "+7 (999) 999 9999",
          clearIncomplete: true,
          oncomplete: function (e) {
            setOwnerData((prev) => ({
              ...prev,
              additionalPhone: e.target.value,
            }));
          },
          onincomplete: function () {
            setOwnerData((prev) => ({ ...prev, additionalPhone: "" }));
          },
        })
        .mask(additionalPhoneInputRef.current);
    }
  }, []);

  return (
    <div className="owner-step">
      <div className="owner-info">
        <p>{address}</p>
        <span>ЛС {accountNumber}</span>
      </div>
      <h1>Введите данные нового собственника жилого помещения</h1>
      <div className="form">
        <div className="form__body">
          {["lastName", "firstName", "middleName"].map((field) => (
            <div className="form__fieldset" style={{ paddingTop: "0" }}>
              <TextInput
                key={field}
                name={
                  field === "lastName"
                    ? "Фамилия"
                    : field === "firstName"
                    ? "Имя"
                    : "Отчество (при наличии)"
                }
                isRequired={field !== "middleName"}
                inputProps={{
                  value: ownerData[field],
                  onChange: handleChange,
                  id: field,
                }}
                errors={errors[field]}
              />
            </div>
          ))}
          {["phone", "additionalPhone"].map((field) => (
            <div className="form__fieldset">
              <div key={field} className="form__item form__item_horizontal">
                <div className="relative">
                  <TextInput
                    name={`${
                      field === "phone"
                        ? "Контактный номер телефона"
                        : "Дополнительный номер телефона"
                    } (подтвердите кодом из СМС)`}
                    isRequired={field === "phone"}
                    inputProps={{
                      value: ownerData[field],
                      onChange: handleChange,
                      disabled: ownerData[`${field}Verified`],
                      id: field,
                      ref:
                        field === "phone"
                          ? phoneInputRef
                          : additionalPhoneInputRef,
                    }}
                    errors={errors[field]}
                  />
                  {ownerData[`${field}Verified`] && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <circle cx="10" cy="10" r="10" fill="#14BA11" />
                      <path
                        d="M5.33203 10.0013L8.66536 13.3346L15.332 6.66797"
                        stroke="white"
                        stroke-width="1.5"
                      />
                    </svg>
                  )}
                </div>
                {!ownerData[`${field}Verified`] && (
                  <Fragment>
                    <button
                      className="button-secondary button-secondary_border-gray"
                      onClick={(e) => {
                        e.preventDefault();
                        sendSmsCode(field);
                      }}
                    >
                      Отправить код
                    </button>
                    <div className="form-field-sms">
                      <TextInput
                        inputProps={{
                          value: ownerData[`${field}SmsCode`],
                          onChange: handleChange,
                          id: `${field}SmsCode`,
                          placeholder: "Код из СМС",
                        }}
                        errors={errors[`${field}SmsCode`]}
                      />
                    </div>
                    <button
                      className="button-primary button-primary_pdv_lg"
                      onClick={(e) => {
                        e.preventDefault();
                        verifySmsCode(`${field}`, `${field}SmsCode`);
                      }}
                      disabled={!ownerData[`${field}SmsCode`] || !token}
                    >
                      Подтвердить
                    </button>
                  </Fragment>
                )}
              </div>
            </div>
          ))}

          <div className="form__fieldset">
            <div className="form__item">
              <TextInput
                name="Электронная почта"
                inputProps={{
                  value: ownerData.email,
                  onChange: handleChange,
                  id: "email",
                }}
                errors={errors.email}
              />
            </div>
          </div>
        </div>

        {/* показываем все ошибки */}
        {Object.values(errors).map((error) => (
          <div className="form__error-text">{error}</div>
        ))}

        {/**/}
        {type === APARTMENT_FORM_TYPE.HERITAGE && (
          <div
            style={{
              fontSize: 16,
              background: "#FFEDE0",
              padding: "20px",
              margin: "0 0 30px 0",
              display: 'flex',
              gap: '20px',
              alignItems: 'center',
              fontWeight: 400
            }}
          >
            <svg
              width="29"
              height="26"
              viewBox="0 0 29 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.4996 18.2707C13.6889 18.2707 13.0093 18.9372 13.0093 19.7324C13.0093 20.5275 13.6889 21.194 14.4996 21.194C15.2806 21.194 15.99 20.5275 15.9542 19.7674C15.99 18.9314 15.3163 18.2707 14.4996 18.2707Z"
                fill="#FF7819"
              />
              <path
                d="M28.2943 23.4509C29.2302 21.8664 29.2362 19.978 28.3062 18.3994L18.9707 2.54329C18.0467 0.947156 16.3775 0 14.5056 0C12.6337 0 10.9645 0.953002 10.0405 2.53744L0.693041 18.4111C-0.236937 20.0072 -0.230976 21.9074 0.710925 23.4918C1.6409 25.0587 3.30413 26 5.16409 26H23.8113C25.6773 26 27.3524 25.047 28.2943 23.4509ZM26.2674 22.3049C25.7488 23.1819 24.8307 23.7023 23.8054 23.7023H5.15813C4.14469 23.7023 3.2326 23.1936 2.72588 22.3342C2.2132 21.463 2.20724 20.4223 2.71992 19.5453L12.0674 3.67753C12.5741 2.80639 13.4802 2.29188 14.5056 2.29188C15.525 2.29188 16.4371 2.81223 16.9438 3.68338L26.2853 19.5512C26.7861 20.4048 26.7801 21.4338 26.2674 22.3049Z"
                fill="#FF7819"
              />
              <path
                d="M14.13 8.00985C13.4206 8.20864 12.9795 8.84008 12.9795 9.60599C13.0152 10.0679 13.0451 10.5356 13.0808 10.9975C13.1822 12.7573 13.2835 14.4821 13.3849 16.2419C13.4206 16.8383 13.8916 17.2709 14.4996 17.2709C15.1077 17.2709 15.5846 16.809 15.6144 16.2068C15.6144 15.8443 15.6144 15.5111 15.6502 15.1427C15.7158 14.0143 15.7873 12.8859 15.8529 11.7575C15.8886 11.0267 15.9542 10.2959 15.99 9.56506C15.99 9.30196 15.9542 9.06809 15.8529 8.83423C15.5488 8.17941 14.8394 7.84615 14.13 8.00985Z"
                fill="#FF7819"
              />
            </svg>
            Наследники, принявшие наследство, отвечают по долгам наследодателя
            солидарно, в соответствии со ст. 1175 Гражданского кодекса РФ
          </div>
        )}

        <button
          className="button-primary button-primary_pdv_lg form__submit-btn"
          onClick={handleNext}
          disabled={!isFormValid}
        >
          Сохранить изменения
        </button>
      </div>
    </div>
  );
}
